import React, { useEffect } from "react";

import useDecodedParams from "Hooks/useDecodedParams";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import {
  organizationByDescriptionIdSelector,
  organizationLoadingSelector,
  organizationEstimateSelector,
  loadOrganizationEstimate
} from "Reducers/organization/organization";
import { useAppSelector, useAppDispatch } from "Store/hooks";

const BillingWrapper = ({ children }: { children: React.ReactNode }) => {
  const dispatch = useAppDispatch();
  const { organizationId } = useDecodedParams<{ organizationId: string }>();
  const organizationIsLoading = useAppSelector(organizationLoadingSelector);

  const organization = useAppSelector(state =>
    organizationByDescriptionIdSelector(state, {
      organizationDescriptionId: organizationId
    })
  );

  const organizationEstimate = useSelectorWithUrlParams(
    organizationEstimateSelector
  );

  useEffect(() => {
    if (organization && !organizationIsLoading && !organizationEstimate) {
      dispatch(loadOrganizationEstimate({ organization }));
    }
  }, [dispatch, organization, organizationIsLoading, organizationEstimate]);

  return <>{children}</>;
};

export default BillingWrapper;
